import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'seo-bike-bfdl',
  templateUrl: './seo-bike-bfdl.component.html'
})
export class SeoBikeBfdlComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    if (document.getElementById('ans1')) { document.getElementById('ans1').style.display = 'none'; }
    if (document.getElementById('ans2')) { document.getElementById('ans2').style.display = 'none'; }
    if (document.getElementById('ans3')) { document.getElementById('ans3').style.display = 'none'; }
    if (document.getElementById('ans4')) { document.getElementById('ans4').style.display = 'none'; }
    if (document.getElementById('ans5')) { document.getElementById('ans5').style.display = 'none'; }
  }

  openAnswer(element) {
    if (element.getElementsByTagName('svg')[0].style.display == "none") {
      element.getElementsByTagName('svg')[0].style.display = "block"
      element.getElementsByTagName('svg')[1].style.display = "none"
      element.nextElementSibling.style.display = 'none';
    } else {
      element.getElementsByTagName('svg')[0].style.display = "none"
      element.getElementsByTagName('svg')[1].style.display = "block"
      element.nextElementSibling.style.display = 'block';
    }
  }
}
